import { Component, OnInit } from '@angular/core';
import { LocalDataSource } from 'ng2-smart-table';
import { AuthorizationService } from '../../service/authorizationService';
import { ConfigurationService } from '../../service/configuration.service';
import { webSocket } from 'rxjs/webSocket';

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { LobbyAuth } from '../../model/lobby-auth';

@Component({
  selector: 'lobby-panel',
  templateUrl: './lobby-panel.component.html',
  styleUrls: ['./lobby-panel.component.scss']
})
export class LobbyPanelComponent implements OnInit {
  private panelId: string = '1';
  private k: string = '123985649@';

  public settings;
  public source: LocalDataSource;
  public setInterval: any;
  public setIntervalChangeAlert: any;
  public setTimerOut: any;
  public loading: boolean;
  public resolution: any;
  public buildingName: string = '';
  public audio: any;
  public noCommunication: boolean = false;
  public audioOn: boolean = false;
  public styleAudioIcon: string = 'volume-off-outline';
  public statusAudioIcon: string = 'basic';
  public emptyVisitorList: boolean = false;
  public lobbyAuths: LobbyAuth;
  public timer: any;

  public updatdeListAux: number = 0;
  public updatdeList: number = 0;

  constructor(
    protected authorizationService: AuthorizationService,
    private config: ConfigurationService,
    private http: HttpClient) { }

  ngOnInit(): void {
    this.loading = true;
    this.audio = new Audio("../../../assets/audio/beepsound-aero.mp3");

    this.updateResolution();
    window.addEventListener('resize', () => { this.updateResolution() });

    this.config.buildingName().subscribe((resp) => {
      let name = resp;
      this.buildingName = name.toUpperCase();
    }, (error) => { console.log("buildingName error: " + error) })
    
    this.lobbyPanel();

    this.setInterval = setInterval(() => {
      this.lobbyPanel();
    }, 5000);
  }

  lobbyPanel() {
    this.authorizationService.lobbyPanel(this.k + this.panelId, this.panelId).subscribe(resp => {
      clearInterval(this.setIntervalChangeAlert);
      this.updatdeListAux = resp.releases.length;

      try {
        if (resp.releases.length != 0 || resp.waiting.length != 0) {
          this.emptyVisitorList = false;

          if ((this.updatdeList != this.updatdeListAux) && (this.updatdeList < this.updatdeListAux)) {
            if (this.audioOn && this.noCommunication == false){
              this.audio.play();
            }
          }

          this.updatdeList = resp.releases.length;

        } else {
          this.emptyVisitorList = true;
        }
      } catch (error) {
        console.log('Error ao obter dados do lobby panel: ', error)
      }
      this.lobbyAuths = resp;
      this.timer = this.lobbyAuths.tmt
      this.loading = false;
      this.noCommunication = false;

    }, (error) => {
      clearInterval(this.setIntervalChangeAlert);
      clearTimeout(this.setTimerOut);
      this.audio.pause();
      this.noCommunication = true;
      this.emptyVisitorList = false;
      console.log("Erro ao tentar comunicar com o servidor: " + error)
    });
  }

  enableAudio() {
    this.audioOn = !this.audioOn;
    if (this.audioOn) {
      this.styleAudioIcon = 'volume-up-outline';
      this.statusAudioIcon = 'info';
    } else {
      this.styleAudioIcon = 'volume-off-outline';
      this.statusAudioIcon = 'basic';
    }
  }

  updateResolution(): void {
    this.resolution = this.getResolution();
    if (this.resolution.width > 1080) {
      document.getElementById('bottomBar').setAttribute('src', '../../../assets/images/barra_inferior_16_9.png')
    } else {
      document.getElementById('bottomBar').setAttribute('src', '../../../assets/images/barra_inferior_9_16.png')
    }
  }

  getResolution(): { width: number; height: number } {
    return {
      width: window.innerWidth,
      height: window.innerHeight,
    };
  }

  ngOnDestroy() {
    clearInterval(this.setInterval);
  }
}
